
import Stream from 'frp/stream'
import { Animation } from 'animation'
import { action, live } from 'actions'
import { lang } from 'lang'

export function getLocalizedPosition(config) {
    if (config['position_' + lang()]) {
        return config['position_' + lang()];
    }
    else {
        return config.position;
    }
}

export function fieldName( obj, field )
{
    for ( const name in obj )
    {
        if ( obj[ name ] === field ) return name;
    }
}

export function Image( name )
{
    const texture = PIXI.utils.TextureCache[ name ]
    if ( ! texture ) {
        let msg = ''
        for ( let i in PIXI.utils.TextureCache ) msg = msg + i + ','
        throw "no texture " + name + '. Available textures: ' + msg
    }
    return new PIXI.Sprite( texture )
}

export function load_source( url )
{
    const scr  = document.createElement( 'script' )
    const head = document.head || document.getElementsByTagName('head')[0]
    scr.src = url
    scr.async = false; // optionally

    head.insertBefore( scr, head.firstChild )
}

export function UrlParamsToObject()
{
    const result = {};
    const pairs = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );

    for ( let i = 0; i < pairs.length; ++i )
    {
        const pair = pairs[ i ].split( '=' );
        let value = pair[ 1 ];
        if ( value === undefined )
        {
            value = true;
        }
        result[ pair[ 0 ] ] = value;
    }
    return result;
}

/** Keep sound playing while previous stream value is true */
Stream.prototype.sound = function({ name, loop = true })
{
    const s = sounds.get( name )
    s.loop( loop )

    return this.on( play => {
        if ( play && ! s.playing() ) s.play()
        if ( ! play && s.playing() ) s.stop()
    })
}
export function kill_sound( s )
{
    try
    {
        //remove all listeners first so that onstop() won't be called as well:
        s.off()
        s.stop()
    }
    catch(e){}
}

/** Get specified deep property from object with fallback to specified value if it cannot be retrieved.
@param object object to obtain property from
@param prop deeply sequenced array of properties to obtain
@param fallback value to return in case specified deep property cannot be retrieved
@param desc literal prefix for console error message when property cannot be retrieved. No message will be printed if not specified.*/
export function get_prop( object, prop, fallback, desc )
{
    for ( let i = 0; i < prop.length; ++ i )
    {
        const prop_name = prop[ i ]
        object = ( object === undefined || object === null ) ? undefined : object[ prop_name ]
        
        if ( object === undefined || object === null )
        {
            if ( desc ) console.error( desc, 'no', prop_name, 'property' )
            return fallback
        }
    }
    return object
}

export function in_iframe()
{
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}

/** Inclusively */
export function random_int( min, max )
{
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function canFullscreen() {
    return !!(
        window.document.documentElement.requestFullscreen ||
        window.document.documentElement.mozRequestFullScreen ||
        window.document.documentElement.webkitRequestFullScreen
    )
}

export function canScreenLock() {
    return !!(window.screen.orientation && window.screen.orientation.lock)
}

export function is_fullscreen() {
    const doc = window.document;

    return !!(doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement)
}

export function positioner( space, target, name )
{
    target.positioner_disp = { x : 0, y : 0 }
    space.s( 'keyboard' ).on( k => {
        switch ( k )
        {
            //left:
            case 37:
                target.positioner_disp.x -= 1
                target.position.x -= 1
                break
            
            //up:
            case 38:
                target.positioner_disp.y -= 1
                target.position.y -= 1
                break
            
            //right:
            case 39:
                target.positioner_disp.x += 1
                target.position.x += 1
                break
            
            //down:
            case 40:
                target.positioner_disp.y += 1
                target.position.y += 1
                break
        }

        console.log( name || target, ':', target.positioner_disp.x, target.positioner_disp.y )
    })
}
export function try_animation( {
    space,
    container,
    template,
    frames,
    delay = 0.15,
    x = 0,
    y = 0,
} )
{
    const t = Animation.byFrameName( template, frames )
    t.position.set( x, y )
    t.animationSpeed = delay
    t.loop = false
    t.visible = false
    container.addChild( t )
    positioner( space, t )
    const a = action()
    space.s( 'ticker' ).on( s => live( a, s ) )
    const q = () => {
        a.push( { callback : () => {
            t.gotoAndPlay( 0 )
            t.visible = true
        } } )
        a.push( { duration : frames * Animation.frame_delay( t ) * 2 } )
        a.push( { callback : () => t.visible = false } )
        a.push( { duration : frames * Animation.frame_delay( t ) } )
        a.push( { callback : q } )
    }
    q()
}

/** Position on Bezier Curve
 * points: [ [ 100, 100 ], [ 200, 200 ], ... ]
 * karet: value from 0 to 1 (values <0 and >1 are undefined (pretty sophisticated curve prolongations))
*/
export function bezier( points, karet )
{
    //resulting point calculation is done by connecting point on first line (line from point 1 to point 2) with point on second line (2-3). It effectively decreases amount of lines (points) by one every time. Then repeat until there will remain no lines
	
    //intermediate array which will be used to modify points:
    let copy = points.map( a => a.slice() )
	
	for ( let i = points.length; i >= 2; -- i )
	{
		for ( let i2 = 0; i2 < ( i - 1 ); ++ i2 )
		{
            const p1 = copy[ i2 ]
            const p2 = copy[ i2 + 1 ]
            for ( const j in p1 ) p1[ j ] = p1[ j ] + ( p2[ j ] - p1[ j ] ) * karet
		}
    }
    
    return copy[ 0 ]
}

export function clone( o )
{
    const r = {}
    for ( const p in o ) if ( o.hasOwnProperty( p ) ) r[ p ] = o[ p ]
    return r
}

/** Сбросить callstack.*/
export function postpone( what, param )
{
    setTimeout(
        function()
        {
            what( param );
        },
        1
    );
}

export function rows_count( spec )
{
    let rows = 0
    //some games have no lines at all:
    if ( spec.specification.linesPaths ) {
        for ( const l of spec.specification.linesPaths ) rows = Math.max( rows, ... l )
        //zero-indexed to count:
        ++ rows
    }
    return rows
}

/** Choose intermediate (interpolated) color between 2 colors specified with v, where color1 will be returned for v=0 and color2 for v=1 */
export function colors_interp( color1, color2, v ) {
    const c1 = PIXI.utils.hex2rgb( color1 )
    const c2 = PIXI.utils.hex2rgb( color2 )
    const r = []
    for ( let i in c1 ) r.push( c1[ i ] + ( c2[ i ] - c1[ i ] ) * v )
    return PIXI.utils.rgb2hex( new Float32Array( r ) )
}

export function hide( o )
{
    if ( o.parent ) o.parent.removeChild( o )
}





// WEBPACK FOOTER //
// ./src/library/utils.es6